// extracted by mini-css-extract-plugin
module.exports =  {"root":"XQL2xLl_Ij1tAhqM7lIp","left":"gYrTzwXvTyhsVeanC_Yh","right":"blq9ZnQbzhdj6Qz0uaTg"};